<!--
 * $Description: 
 * $Author: Betway
 * @LastEditors: Please set LastEditors
 * $Date: 2020年05月29日 10:43:18 +0800
 * @LastEditTime: 2021-01-26 15:35:11
 * @FilePath: \mrc-base-server-view\src\components\mrc_ess_noContent.vue
-->
<template>
  <v-container class="max-width d-flex flex-grow-1 ma-0 pa-0 flex-column justify-center text-center body-2 align-center align-self-center"
               :style="{height:height+'px'}"
               :elevation="0"
               color="grey--text text--lighten-1">
    <!-- <div class="max-width text-center">
      <mrc_ess_svgIcon iconClass='tablenone'
                       :style="{'font-size':svgFontSize+'px'}"></mrc_ess_svgIcon>
    </div> -->
    <template v-if="type==1">
      <mrc_ess_svgIcon iconClass='tablenone'
                       :style="{'font-size':svgFontSize+'px'}"></mrc_ess_svgIcon>
      <div class="mt-n3"
           style="font-size：16px;color:rgba(0, 0, 0, 0.38);font-weight: 500">{{ $t(no_data_text) }}</div>
    </template>
    <template v-else>
      <div class="d-flex justify-center align-center">
        <mrc_ess_svgIcon iconClass='tablenone'
                         :style="{'font-size':svgFontSize+'px'}"></mrc_ess_svgIcon>
        <div style="font-size：16px;color:rgba(0, 0, 0, 0.38);font-weight: 500">{{ $t(no_data_text) }}</div>
      </div>
    </template>
  </v-container>
</template>
<script>
export default {
  name: 'mrc_ess_noContent',
  props: {
    no_data_text: { default: 'label_nullData', type: String },
    height: { default: '200' },
    svgFontSize: { default: '100' },
    type: { default: 1 },
  },
  data () {
    return {}
  },
}
</script>
